// import React from "react";
// import "../css/styles.css" // Import external CSS

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <p>&copy; {new Date().getFullYear()} Nyatwende Travel & Tours. All rights reserved.</p>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaEnvelope, FaPhone, FaWhatsapp, FaCcVisa, FaCcMastercard, FaShieldAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../css/styles.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-grid">
          {/* Column 1: Company */}
          <div className="footer-col">
            <h4 className="footer-col-title">Nyatwende Travel & Tours</h4>
            <p className="footer-col-desc">
              Tailor-made safaris across Kenya, Tanzania and Zanzibar — crafted with care by local experts.
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/profile.php?id=61572586970183" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook className="icon" />
              </a>
              <a href="https://www.instagram.com/nyatwende_africatours?igsh=MXBlbTN5bWZscWExeg%3D%3D" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram className="icon" />
              </a>
              <a href="https://x.com/i/flow/login?redirect_after_login=%2FRugi_Njaamunge" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter className="icon" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin className="icon" />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/tours">Safari Packages</Link></li>
              <li><Link to="/handpicked-stays">Handpicked Stays</Link></li>
              <li><Link to="/destinations">Destinations</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div className="footer-col">
            <h4 className="footer-col-title">Contact Us</h4>
            <div className="footer-contact-item">
              <FaEnvelope className="footer-contact-icon" />
              <div>
                <a href="mailto:info@nyatwende.com">info@nyatwende.com</a><br />
                <a href="mailto:bookings@nyatwende.com">bookings@nyatwende.com</a>
              </div>
            </div>
            <div className="footer-contact-item">
              <FaPhone className="footer-contact-icon" />
              <div>
                <a href="tel:+254706136146">+254 706 136 146</a><br />
                <a href="tel:+254798178735">+254 798 178 735</a>
              </div>
            </div>
            <div className="footer-contact-item">
              <FaWhatsapp className="footer-contact-icon" />
              <div>
                <a href="https://wa.me/254706136146" target="_blank" rel="noopener noreferrer">WhatsApp Us</a>
              </div>
            </div>
          </div>

          {/* Column 4: Trust & Payments */}
          <div className="footer-col">
            <h4 className="footer-col-title">Trusted & Secure</h4>
            <div className="footer-trust-badges">
              <div className="footer-trust-badge">
                <FaShieldAlt className="footer-trust-icon" />
                <span>TRA Licensed</span>
              </div>
              <div className="footer-trust-badge">
                <FaShieldAlt className="footer-trust-icon tripadvisor" />
                <span>Tripadvisor</span>
              </div>
            </div>
            <h4 className="footer-col-title footer-payment-title">We Accept</h4>
            <div className="footer-payment-icons">
              <div className="footer-payment-badge" title="M-Pesa">
                <span className="footer-payment-text">M-Pesa</span>
              </div>
              <div className="footer-payment-badge" title="Visa">
                <FaCcVisa className="footer-payment-icon" />
              </div>
              <div className="footer-payment-badge" title="Mastercard">
                <FaCcMastercard className="footer-payment-icon" />
              </div>
              <div className="footer-payment-badge" title="Pesapal">
                <span className="footer-payment-text">Pesapal</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Nyatwende Travel & Tours. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;